<template>
  <Dialog
    v-model:visible="mostrarModal"
    :style="{ width: '650px' }"
    header="GENERAR FACTURA ELECTRÓNICA"
    :modal="true"
    class="p-fluid"
    @hide="ocultarDialog"
  >
    <!-- Información de la Venta - 2 Filas Compactas -->
    <div class="venta-info-card mb-3">
      <div class="grid">
        <!-- Primera Fila -->
        <div class="field col-12 md:col-3">
          <div class="info-item">
            <i class="pi pi-shopping-cart"></i>
            <div>
              <span class="info-label">ID Venta</span>
              <strong>#{{ data_factura.id }}</strong>
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-3">
          <div class="info-item">
            <i class="pi pi-calendar"></i>
            <div>
              <span class="info-label">Fecha</span>
              <strong>{{
                formatearFechaCorta(data_factura.fecha_venta)
              }}</strong>
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-3">
          <div class="info-item">
            <i class="pi pi-credit-card"></i>
            <div>
              <span class="info-label">Método Pago</span>
              <strong>{{ data_factura.metodo_pago_nombre }}</strong>
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-3">
          <div class="info-item total-item">
            <i class="pi pi-dollar"></i>
            <div>
              <span class="info-label">Total</span>
              <strong class="total-amount"
                >Bs. {{ data_factura.total_cancelar }}</strong
              >
            </div>
          </div>
        </div>

        <!-- Segunda Fila -->
        <div class="field col-12 md:col-4">
          <div class="info-item">
            <i class="pi pi-user"></i>
            <div>
              <span class="info-label">Paciente</span>
              <strong>{{ data_factura.nombre_cliente }}</strong>
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <div class="info-item">
            <i class="pi pi-id-card"></i>
            <div>
              <span class="info-label">NIT / CI</span>
              <strong>{{ data_factura.nit || "" }}</strong>
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <div class="info-item">
            <i class="pi pi-id-card"></i>
            <div>
              <span class="info-label">Médico</span>
              <strong>{{ data_factura.nombre_medico }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Nota informativa -->
    <div class="nota-info mb-3">
      <i class="pi pi-info-circle"></i>
      <span
        >Presione <strong>Enter</strong> o <strong>Buscar</strong> para
        verificar el NIT/CI</span
      >
    </div>

    <!-- Formulario en UNA LÍNEA -->
    <div class="p-fluid formgrid grid">
      <!-- NIT/CI -->
      <div class="field col-12 md:col-5">
        <span class="label-nit"
          ><strong>NIT / CI:</strong> <span class="p-invalid">*</span></span
        >
        <div class="p-inputgroup">
          <InputNumber
            v-model="data_factura.nit"
            placeholder="Mínimo 5 dígitos"
            mode="decimal"
            :useGrouping="false"
            @keyup.enter="buscarClientePorNit"
            :class="{ 'p-invalid': errors.nit }"
          />
          <Button
            icon="pi pi-search"
            class="p-button-warning"
            v-tooltip.top="'Buscar (Enter)'"
            @click="buscarClientePorNit"
            :loading="buscandoNit"
          />
          <Button
            icon="pi pi-user-plus"
            class="p-button-info"
            v-tooltip.top="'Nuevo Cliente'"
            @click="activarClienteFactura"
            :disabled="buscandoNit"
          />
        </div>
        <small class="p-invalid" v-if="errors.nit">{{ errors.nit[0] }}</small>
      </div>

      <!-- Razón Social -->
      <div class="field col-12 md:col-7">
        <span class="label-razon"
          ><strong>RAZÓN SOCIAL :</strong>
          <span class="p-invalid">*</span></span
        >
        <Textarea
          v-model="data_factura.razon_social"
          placeholder="Se completa al buscar"
          rows="1"
          autoResize
          readonly
          :class="{ 'p-invalid': errors.razon_social }"
        />
        <small class="p-invalid" v-if="errors.razon_social">{{
          errors.razon_social[0]
        }}</small>
      </div>
    </div>

    <!-- Productos - Colapsable -->
    <div
      class="productos-section mb-3"
      v-if="data_factura.productos && data_factura.productos.length > 0"
    >
      <div
        class="productos-header"
        @click="mostrarProductos = !mostrarProductos"
      >
        <span
          ><i class="pi pi-list"></i>
          <strong
            >PRODUCTOS/SERVICIOS ({{ data_factura.productos.length }})</strong
          ></span
        >
        <i
          :class="mostrarProductos ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
        ></i>
      </div>
      <transition name="slide">
        <div class="productos-body" v-show="mostrarProductos">
          <div
            v-for="(producto, index) in data_factura.productos"
            :key="index"
            class="producto-item"
          >
            <span class="producto-nombre">{{ producto.descripcion }}</span>
            <span class="producto-cantidad"
              >x{{ producto.pivot?.cantidad || 1 }}</span
            >
            <span class="producto-precio"
              >Bs. {{ formatearPrecio(producto.pivot?.precio || 0) }}</span
            >
          </div>
        </div>
      </transition>
    </div>

    <template #footer>
      <div class="footer-actions">
        <small class="footer-note">
          <i class="pi pi-exclamation-circle"></i>
          <span class="p-invalid">*</span> CAMPOS REQUERIDOS
        </small>
        <div>
          <Button
            label="CANCELAR"
            icon="pi pi-times"
            class="p-button-secondary"
            @click="ocultarDialog"
            :disabled="enviado"
          />
          <Button
            label="EMITIR FACTURA"
            icon="pi pi-send"
            class="p-button-info ml-2"
            @click="guardarVentaFactura"
            :loading="enviado"
            :disabled="!puedeFacturar"
          />
        </div>
      </div>
    </template>
  </Dialog>

  <!-- Modal de Cliente Factura -->
  <ClienteFactura
    :show="clienteFacturaModal"
    :cliente_factura="cliente_factura"
    @closeModal="cerrarModalClienteFactura"
    @actualizarListado="buscarClientePorNit"
  />
</template>

<script>
import VentaService from "@/service/VentaService";
import ClienteService from "@/service/ClienteService";
import ClienteFactura from "@/module/clientes_facturas/ClienteFactura.vue";

export default {
  components: {
    ClienteFactura,
  },
  emits: ["closeModal", "actualizarListado"],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    ventaFactura: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      mostrarModal: this.show,
      data_factura: this.ventaFactura,
      errors: {},
      enviado: false,
      cliente_factura: { estado: { label: "ACTIVO", value: 1 } },
      clienteFacturaModal: false,
      buscandoNit: false,
      mostrarProductos: false,
    };
  },
  computed: {
    puedeFacturar() {
      return (
        this.data_factura.nit &&
        this.data_factura.nit.toString().length >= 5 &&
        this.data_factura.razon_social &&
        !this.enviado &&
        !this.buscandoNit
      );
    },
  },
  created() {
    this.ventaService = new VentaService();
    this.clienteService = new ClienteService();
  },
  methods: {
    formatearFechaCorta(fecha) {
      if (!fecha) return "N/A";
      const date = new Date(fecha);
      return date.toLocaleDateString("es-BO", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    formatearPrecio(precio) {
      return parseFloat(precio).toFixed(2);
    },
    activarClienteFactura() {
      this.clienteFacturaModal = true;
      this.cliente_factura = {
        estado: { label: "ACTIVO", value: 1 },
        ci_nit: this.data_factura.nit ?? "",
      };
    },
    cerrarModalClienteFactura() {
      this.clienteFacturaModal = false;
      this.cliente_factura = { estado: { label: "ACTIVO", value: 1 } };
    },
    buscarClientePorNit() {
      if (
        !this.data_factura.nit ||
        this.data_factura.nit.toString().length < 5
      ) {
        this.$toast.add({
          severity: "warn",
          summary: "Atención",
          detail: "El NIT/CI debe tener al menos 5 dígitos",
          life: 3000,
        });
        return;
      }

      this.buscandoNit = true;
      this.clienteService
        .buscarClientePorNit({ nit: this.data_factura.nit })
        .then((response) => {
          this.buscandoNit = false;

          // Verificar validez del NIT
          if (response.nit_valido === false) {
            this.$toast.add({
              severity: "error",
              summary: "NIT Inválido",
              detail: response.mensaje || "El NIT no es válido según el SIN",
              life: 5000,
            });
            this.data_factura.razon_social = "";
            return;
          }

          // NIT válido
          if (response.cliente != null) {
            this.$toast.add({
              severity: "success",
              summary: "Cliente Encontrado",
              detail: "Datos cargados correctamente",
              life: 3000,
            });
            let nombre_cliente =
              response.cliente.nombre_cliente ?? response.cliente;
            this.data_factura.razon_social = nombre_cliente ?? "";
          } else {
            this.$toast.add({
              severity: "info",
              summary: "Cliente No Encontrado",
              detail: "¿Desea registrar un nuevo cliente?",
              life: 4000,
            });
            this.data_factura.razon_social = "";
            setTimeout(() => {
              this.activarClienteFactura();
            }, 500);
          }
        })
        .catch(() => {
          this.buscandoNit = false;
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "No se pudo verificar el NIT/CI",
            life: 3000,
          });
        });
    },
    guardarVentaFactura() {
      if (!this.puedeFacturar) {
        this.$toast.add({
          severity: "error",
          summary: "Datos Incompletos",
          detail: "Complete todos los campos requeridos",
          life: 3000,
        });
        return;
      }

      this.errors = {};
      this.enviado = true;

      this.ventaService
        .crear_factura(this.data_factura)
        .then((response) => {
          if (response.errors) {
            this.errors = response.errors;
            this.$toast.add({
              severity: "error",
              summary: "Error de Validación",
              detail: response.message,
              life: 5000,
            });
            this.enviado = false;
          } else if (response.status == 400 || response.status == 500) {
            this.$toast.add({
              severity: "error",
              summary: "Error al Facturar",
              detail: response.message,
              life: 5000,
            });
            this.enviado = false;
          } else {
            this.$toast.add({
              severity: "success",
              summary: "¡Factura Generada!",
              detail: "La factura electrónica se generó exitosamente",
              life: 3000,
            });
            this.$emit("actualizarListado");
            this.ocultarDialog();
            this.imprimirVenta(this.data_factura.id);
          }
        })
        .catch((error) => {
          this.enviado = false;
          this.$toast.add({
            severity: "error",
            summary: "Error Inesperado",
            detail: error.message || "Ocurrió un error al procesar la factura",
            life: 5000,
          });
        });
    },
    ocultarDialog() {
      this.mostrarModal = false;
      this.$emit("closeModal");
      this.enviado = false;
      this.errors = {};
    },
    imprimirVenta(id) {
      this.ventaService
        .imprimirVenta(id)
        .then(() => {
          console.log("Factura enviada a impresión");
        })
        .catch((error) => console.error("Error al imprimir:", error));
    },
  },
  watch: {
    show(value) {
      this.mostrarModal = value;
    },
    ventaFactura(value) {
      this.data_factura = { ...value };
      this.data_factura.razon_social = null;
      // Verifico si tine NIT para buscar cliente
      if (this.data_factura.nit) {
        this.$nextTick(() => {
          this.buscarClientePorNit();
        });
      }
      this.errors = {};
      this.mostrarProductos = false;
    },
  },
};
</script>

<style scoped lang="scss">
// Card de info - SIN FONDO AZUL
.venta-info-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  .field {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }

  .info-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    i {
      font-size: 1.1rem;
      color: #667eea;
    }

    div {
      display: flex;
      flex-direction: column;
      gap: 0.1rem;
    }

    .info-label {
      font-size: 0.7rem;
      color: #64748b;
      text-transform: uppercase;
      letter-spacing: 0.3px;
    }

    strong {
      font-size: 0.9rem;
      font-weight: 600;
      color: #1e293b;
    }

    &.total-item {
      i {
        color: #10b981;
      }
      .total-amount {
        font-size: 1.3rem;
        font-weight: 700;
        color: #10b981;
      }
    }
  }
}

// Nota informativa
.nota-info {
  background: #fef3c7;
  border-left: 3px solid #f59e0b;
  padding: 0.6rem 0.8rem;
  border-radius: 6px;
  display: flex;
  gap: 0.5rem;
  align-items: center;

  i {
    color: #f59e0b;
    font-size: 1rem;
  }

  span {
    color: #92400e;
    font-size: 0.85rem;
  }
}

.label-nit {
  font-size: 1rem;
  display: inline-block;
}

.label-razon {
  font-size: 1rem;
  display: inline-block;
}

// Productos colapsables
.productos-section {
  .productos-header {
    background: #f8f9fa;
    padding: 0.75rem 1rem;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.2s;

    &:hover {
      background: #e9ecef;
    }

    span {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      color: #495057;
      font-size: 0.9rem;
    }

    i {
      color: #6c757d;
      font-size: 0.8rem;
    }
  }

  .productos-body {
    background: #f8f9fa;
    border-radius: 0 0 8px 8px;
    padding: 0.5rem 1rem 1rem 1rem;
    max-height: 150px;
    overflow-y: auto;

    .producto-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.5rem 0.75rem;
      background: white;
      border-radius: 5px;
      margin-bottom: 0.4rem;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

      &:last-child {
        margin-bottom: 0;
      }

      .producto-nombre {
        flex: 1;
        font-size: 0.85rem;
        color: #495057;
        font-weight: 500;
      }

      .producto-cantidad {
        font-size: 0.8rem;
        color: #6c757d;
        margin: 0 0.75rem;
      }

      .producto-precio {
        font-weight: 600;
        color: #10b981;
        font-size: 0.9rem;
      }
    }
  }
}

// Animación slide
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
  max-height: 200px;
  overflow: hidden;
}

.slide-enter-from,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
}

// Footer
.footer-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .footer-note {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    color: #002236;
    font-size: 1rem;
    font-weight: 600;

    i {
      color: #dc3545;
    }
  }
}

.p-invalid {
  color: #dc3545;
  font-size: 1rem;
  font-weight: 600;
}
</style>
